{
  "title": "Gerenciar Licenças",
  "loading": "Carregando licenças...",
  "buyLicenses": "Comprar licenças",
  "product": "Produto",
  "frequency": "Frequência",
  "paymentMethod": "Método de pagamento",
  "status": "Status",
  "nextInvoice": "Próxima fatura",
  "actions": "Ações",
  "annual": "Faturamento anual",
  "monthly": "Faturamento mensal",
  "manual": "Faturamento manual",
  "cancelAtPeriodEnd": "Cancela em",
  "trialExpiresOn": "Teste grátis termina em",
  "invoiceAmount": "no valor de",
  "nextInvoiceOn": "Próxima fatura em",
  "manageSubscription": "Gerenciar assinatura",
  "invoices": "Faturas",
  "loadingInvoices": "Carregando faturas...",
  "noInvoices": "Nenhuma fatura encontrada",
  "download": "Baixar",
  "view": "Ver",
  "showing": "Exibindo",
  "of": "de",
  "previous": "Anterior",
  "page": "Página",
  "next": "Próxima",
  "error": "Erro",
  "errorFetchingInvoices": "Erro ao buscar faturas",
  "errorOpeningInvoice": "Erro ao abrir a fatura",
  "errorManageSubscription": "Erro ao abrir o portal de cobrança"
  ,
  "defaultProductName": "Controle de Horas",
  "gpsLicensesSection": "Licenças de Rastreamento GPS",
  "hoursLicensesSection": "Licenças de Controle de Horas",
  "noGpsLicenses": "Nenhuma licença de rastreamento GPS",
  "noHoursLicenses": "Nenhuma licença de controle de horas",
  "noLicenses": "Nenhuma licença ativa",
  "products": {
    "time_control": "Controle de Horas",
    "gps_tracking": "Rastreamento GPS"
  },
  "statusLabels": {
    "active": "Ativo",
    "trialing": "Teste grátis",
    "canceled": "Cancelado",
    "past_due": "Vencido",
    "unpaid": "Não pago",
    "incomplete": "Incompleto",
    "incomplete_expired": "Incompleto expirado"
  }
}

